import React, { useState } from "react";
import "../Plan/Plan.css";
import Icard from "../Icard/Icard";
const Plan = () => {
  const [isIcardOpen, setIsIcardOpen] = useState(false);

  const openIcard = () => {
    setIsIcardOpen(true);
  };

  const closeIcard = () => {
    setIsIcardOpen(false);
  };

  return (
    <div className="plan-section">
      {isIcardOpen && <Icard onClose={closeIcard} />}
      <div className="image-grid">
        <div className="image-card" onClick={openIcard}>
          <h2>Ground Floor Plan</h2>
          <img src="gf.webp" alt="Plan 1" />
        </div>
        <div className="image-card" onClick={openIcard}>
          <h2>First Floor Plan</h2>
          <img src="ff.webp" alt="Plan 2" />
        </div>
        <div className="image-card" onClick={openIcard}>
          <h2>Typical Floor Plan</h2>
          <img src="tf.webp" alt="Plan 3" />
        </div>
      </div>
      {/*--
      {selectedImage && (
        <div className="overlay-p" onClick={closeOverlay}>
          <div className="overlay-content-p">
            
            <img src={selectedImage} alt="Full Plan" className="full-image-p" />
            <span className="close-btnn-p" onClick={closeOverlay}>&times;</span>
          </div>
        </div>
      )}
      -*/}
    </div>
  );
};

export default Plan;
